const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getAutocheckNMVTISReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'AUTOCHECK_NMVTIS_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'AUTOCHECK_NMVTIS_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'AUTOCHECK_NMVTIS_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'AUTOCHECK_NMVTIS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getAutocheckNMVTISReducer;


// WEBPACK FOOTER //
// ./src/reducers/getAutocheckNMVTISReport.js